import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { createOrderApi } from "../../Apis/OrderApi";
import { UserAuthContext } from "../../App";
import { CartorderSendSVG, OrderSendTickSVG } from "../../assets/svg/allSvg";
import { CurrencyContext } from "../../provider/CurrencyProvider";

const CartPanel = ({
  isOpen,
  onClose,
  moq,
  image,
  name,
  productID,
  storeID,
  sellerName,
  price,
}) => {
  const [quantity, setQuantity] = useState(parseInt(moq[0][0]));
  const [orderStatus, setOrderStatus] = useState("Send Order Request"); // State to track button text
  const [isPopupOpen, setIsPopupOpen] = useState(false); // State to manage popup visibility

  const { calculatedPrice, getCurrencySymbol } = useContext(CurrencyContext);


  const { userUid } = useContext(UserAuthContext);

  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState('');
  const [inputValue, setInputValue] = useState('');

  // Load text from localStorage when the component mounts
  useEffect(() => {
    const savedText = localStorage.getItem('editableText');
    if (savedText) {
      setText(savedText);
    }
  }, []);

  const handleEditClick = () => {
    setIsEditing(true);
    setInputValue(text);
  };

  const handleSaveClick = () => {
    if (inputValue.trim()) {
      setText(inputValue);
      setIsEditing(false);
      // Save the input value to localStorage
      localStorage.setItem('editableText', inputValue);
    }
  };

  const handleAddOrder = async () => {
    const res = await createOrderApi(
      "V30xnzvOWdPG4wcJAFuqO13UT2v2",
      storeID,
      productID,
      totalPrice,
      sellerName,
      "",
      quantity,
      "Pending"
    );

    // console.log(res);
  };

  const [totalPrice, setTotalPrice] = useState(
    parseInt(moq[0][0]) * parseInt(price)
  );

  const increment = () => {
    setQuantity(quantity + 1);


    if (parseInt(moq.length) > 0 && quantity < parseInt(moq[0][1])) {
      price = parseInt(moq[0][2]);
    } else if (parseInt(moq.length) > 1 && quantity < parseInt(moq[1][1])) {
      price = parseInt(moq[1][2]);
    } else if (parseInt(moq.length) > 2 && quantity < parseInt(moq[2][1])) {
      price = parseInt(moq[2][2]);
    } else if (parseInt(moq.length) > 3) {
      if (parseInt(moq.length) >= 3 && quantity < parseInt(moq[3][1])) {
        price = parseInt(moq[3][2]);
      }
    }
    setTotalPrice(quantity * price);
  };

  const decrement = () => {
    if (quantity <= parseInt(moq[0][0])) return;

    setQuantity(quantity - 1);


    if (quantity > parseInt(moq[0][1]) && parseInt(moq.length) > 0) {
      price = parseInt(moq[0][2]);
    } else if (parseInt(moq.length) > 1 && quantity > parseInt(moq[1][1])) {
      price = parseInt(moq[1][2]);
    } else if (parseInt(moq.length) > 2 && quantity > parseInt(moq[2][1])) {
      price = parseInt(moq[2][2]);
    } else if (parseInt(moq.length) > 3) {
      if (parseInt(moq.length) >= 3 && quantity > parseInt(moq[3][1])) {
        price = parseInt(moq[3][2]);
      }
    }

    alert(parseInt(price));

    setTotalPrice(quantity * parseInt(price));
  };

  const handleOrderRequest = () => {
    if (orderStatus === "Send Order Request") {
      // Open the popup
      setIsPopupOpen(true);

      // Change the button text
      setOrderStatus("Order Requested");
    }
  };

  const handleCombinedClick = () => {
    handleAddOrder();
    handleOrderRequest();
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-40 flex items-center justify-center">
          <div className="fixed inset-0 bg-black opacity-30" onClick={onClose}></div>
          <div
            className={`absolute inset-0 m-auto z-50 w-[447px] h-[684px] rounded-[10px] bg-white shadow-lg ${isOpen ? "translate-y-0" : "translate-y-full"
              } transition-transform duration-300 ease-in-out`}
            style={{ top: "0", left: "0", transform: "translate(120%,0)" }}
          >
            <div className="flex flex-col h-[30px] items-start justify-between mt-[19px] px-[24px]">
              <h2 className="w-[79px] h-[21px] text-black font-semibold text-[14px] text-start">
                Start Order
              </h2>
              <button onClick={onClose} className="text-gray-600 focus:outline-none">
                <hr className="w-[129px] h-[3px] bg-[#FF6300] rounded-full" />
              </button>
            </div>
            <div className="w-full h-[635px] flex flex-col justify-between">
              <div className="flex flex-col pt-[20px] px-[24px]">
                <div className="w-[398px] h-[267px] rounded-[5px] bg-white border pt-[23px] px-[18px] pb-[18px] flex flex-col">
                  <div className="flex flex-row w-[362px] items-center justify-between">
                    <img src={image} alt="" className="w-[38px] h-[47px]" />
                    <div className="w-[307px] h-[47px] flex flex-col items-start justify-between">
                      <h3 className="w-[307px] h-[21px] font-semibold text-[14px] text-black text-start">
                        {name.slice(0, 32)}...
                      </h3>
                      <p className="w-[250px] h-[18px] text-black font-medium text-[12px] text-start">
                        Seller : {sellerName}
                      </p>
                    </div>
                  </div>
                  <hr className="w-[362px] h-[1px] rounded-full bg-[#D8D8D8] mt-[26px]" />
                  <div className="flex flex-row mt-[15px] h-[132px]">
                    <div className="w-[150px] h-[132px] flex flex-col">
                      <p className="w-[54px] h-[18px] text-black font-semibold text-[12px] text-start">
                        Quantity
                      </p>
                      <hr className="w-[84px] bg-[#FF6300] h-[2px] rounded-full mt-[4px]" />
                      <ul className="list-disc mt-[8px] text-black">
                        {moq.map((item, index) => (
                          <li className="font-medium mt-[8px] text-[12px]">
                            {item[0]}-{item[1]}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="w-[210px] h-[132px] flex flex-col">
                      <p className="w-[66px] h-[18px] text-black font-semibold text-[12px] text-start">
                        Price / Unit
                      </p>
                      <hr className="w-[90px] bg-[#FF6300] h-[2px] rounded-full mt-[4px]" />

                      <ul className="list-disc mt-[8px] text-black">
                        {moq.map((item, index) => (
                          <li className="font-medium mt-[8px] text-[12px]">
                            <li className="font-medium text-[12px] w-[210px] flex items-center gap-x-[11px]">
                              {getCurrencySymbol()}{" "} {calculatedPrice(item[2])}{" "}
                              {index != 0 && (
                                <span className="w-[54px] h-[21px] rounded-[4px] bg-[#72C62F] flex items-center justify-center text-white font-medium text-[10px]">
                                  {index}0 % Off
                                </span>
                              )}
                            </li>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <h3 className="w-[91px] h-[18px] font-semibold text-[12px] text-black mt-[23px]">
                  Order Quantity
                </h3>
                <div className="flex flex-row items-center justify-between mt-[14px]">
                  <div className="w-[116px] h-[40px] border flex items-center justify-around rounded-[5px]">
                    <button
                      className="bg-white text-black font-medium text-[16px] select-none"
                      onClick={decrement}
                    >
                      -
                    </button>
                    <span className="px-4 font-medium text-[16px]">{quantity}</span>
                    <button
                      className="bg-white text-black font-medium text-[16px] select-none"
                      onClick={increment}
                    >
                      +
                    </button>
                  </div>
                  <p className="w-auto h-[18px] font-semibold text-[12px] text-black text-start">
                    Total :{" "}
                    <span className="w-[73px] h-[21px] text-[#FF6300] text-start font-semibold text-[14px]">
                      {getCurrencySymbol()}{" "} {calculatedPrice(totalPrice)}
                    </span>
                  </p>
                </div>
                <div className="flex flex-row items-start mt-[11px]">
                  <p className="w-[157px] h-[18px] font-medium text-[12px] text-black">
                    Minimum Order Quantity :
                  </p>
                  <p className="w-[70px] h-[18px] text-start text-[#FF6300] font-semibold text-[12px]">
                    {moq[0][0]} Units
                  </p>
                </div>
                <div className="flex flex-row items-center justify-between mt-[51px]">
                  <p className="w-[110px] h-[16px] text-start text-black font-semibold text-[12px]">
                    Shipping Location
                  </p>
                  {/* <button className="w-[77px] h-[26px] border rounded-[5px] flex items-center justify-center font-medium text-[12px] text-black">
                    Edit
                  </button> */}
                  <button
                    className="w-[77px] h-[26px] border rounded-[5px] flex items-center justify-center font-medium text-[12px] text-black"
                    onClick={isEditing ? handleSaveClick : handleEditClick}
                    disabled={isEditing && !inputValue.trim()}
                  >
                    {isEditing ? 'Save' : 'Edit'}
                  </button>
                </div>
                {/* <p className="w-[398px] h-[57px] font-medium text-[11px] text-black text-start py-[4px] leading-[23px]">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do foro
                  ent eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p> */}
                {isEditing ? (
                  <textarea
                    className="w-[398px] h-[57px] font-medium text-[11px] text-black text-start py-[4px] leading-[23px] placeholder:text-[#979797]"
                    placeholder="Enter Shipping Location"
                    rows={3}
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                  />
                ) : (
                  <p className="w-[398px] h-[57px] font-medium text-[11px] text-black text-start py-[4px] leading-[23px]">
                    {text}
                  </p>
                )}
              </div>
              <div className="w-full h-[70px] rounded-b-[10px] bg-[#F8F8F8] px-[24px] py-[16px] flex items-center justify-between">
                <h3 className="w-auto h-[21px] text-black text-start font-semibold text-[14px]">
                  Total : {getCurrencySymbol()}{" "} {calculatedPrice(totalPrice)}
                </h3>
                <button
                  className="gap-x-[8px] bg-[#FF6300] text-white flex items-center justify-center rounded-[5px] w-[171px] h-[38px]"
                  onClick={handleCombinedClick}
                  disabled={orderStatus === "Order Requested"} // Disable if already requested
                >
                  {orderStatus === true ? (
                    "faf"
                  ) : (
                    <>
                      {CartorderSendSVG}
                      <p className="w-[121px] h-[18px] font-semibold text-[12px]">
                        {orderStatus}
                      </p>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isPopupOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="fixed inset-0 bg-black opacity-50" onClick={handleClosePopup}></div>
          <div className="relative bg-white w-[869px] h-[368px] flex flex-col items-center justify-center rounded-[10px] shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)] gap-y-[30px] z-50">
            <p className="w-[107px] h-[107px] bg-[#0097B2] rounded-full flex items-center justify-center">{OrderSendTickSVG}</p>
            <h3 className="w-[122px] h-[24px] font-semibold text-[16px] text-black">Request Sent !!</h3>
            <p className="w-[325px] h-[52px] text-center text-black font-medium text-[14px] leading-[27px]">Your order request has been sent to the seller.
              We will notify you once the seller responds.</p>
          </div>
        </div>
      )}
    </>
  );
};

export default CartPanel;
